import { ProductSlide } from './ProductSlide';
import type { ProductSlideshowSlide } from '../product-slideshow.types';

interface ProductSlideshowDesktopSectionProps {
  slide: ProductSlideshowSlide;
  isProductRight: boolean;
}

export function ProductSlideshowDesktopSection({ slide, isProductRight }: ProductSlideshowDesktopSectionProps) {
  return (
    <div
      className={`md:flex items-center justify-center w-full min-h-[33rem] max-w-[24.1875rem] hidden ${
        isProductRight ? 'md:order-3' : 'order-1'
      }`}
    >
      <div className="relative w-full">
        <ProductSlide {...slide} />
      </div>
    </div>
  );
}
